module.exports = __webpack_public_path__ + "img/Admin.6949b1d0.png";